var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  staticClass: "flex-1",
                  attrs: {
                    filterable: "",
                    placeholder: _vm.$t("pleaseChoose")
                  },
                  on: { change: _vm.envIdChange },
                  model: {
                    value: _vm.paramsData.env_id,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "env_id", $$v)
                    },
                    expression: "paramsData.env_id"
                  }
                },
                _vm._l(_vm.szgmEnv, function(item) {
                  return _c("el-option", {
                    key: item.label,
                    attrs: { label: item.label, value: item.id }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    filterable: "",
                    placeholder: _vm.$t("serverChannel")
                  },
                  on: { change: _vm.serverChange },
                  model: {
                    value: _vm.server_channel,
                    callback: function($$v) {
                      _vm.server_channel = $$v
                    },
                    expression: "server_channel"
                  }
                },
                _vm._l(_vm.serverChannel, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: _vm.$t("showTestServer")
                  },
                  on: { change: _vm.serverChannelChange },
                  model: {
                    value: _vm.show_test,
                    callback: function($$v) {
                      _vm.show_test = $$v
                    },
                    expression: "show_test"
                  }
                },
                _vm._l(_vm.serverType, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    multiple: "",
                    "collapse-tags": "",
                    filterable: "",
                    placeholder: _vm.$t("server")
                  },
                  on: { change: _vm.severChange },
                  model: {
                    value: _vm.paramsData.server_id,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "server_id", $$v)
                    },
                    expression: "paramsData.server_id"
                  }
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      on: { change: _vm.selectAll },
                      model: {
                        value: _vm.checked,
                        callback: function($$v) {
                          _vm.checked = $$v
                        },
                        expression: "checked"
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("selectAll")) + " ")]
                  ),
                  _vm._l(_vm.serverListYJ, function(item) {
                    return _c("el-option", {
                      key: item.serverID,
                      attrs: { label: item.serverName, value: item.serverID }
                    })
                  })
                ],
                2
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { placeholder: _vm.$t("gameUid"), clearable: "" },
                model: {
                  value: _vm.paramsData.uid,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "uid", $$v)
                  },
                  expression: "paramsData.uid"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { placeholder: _vm.$t("orderId"), clearable: "" },
                model: {
                  value: _vm.paramsData.order_id,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "order_id", $$v)
                  },
                  expression: "paramsData.order_id"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { placeholder: _vm.$t("productId"), clearable: "" },
                model: {
                  value: _vm.paramsData.product_id,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "product_id", $$v)
                  },
                  expression: "paramsData.product_id"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: _vm.$t("paymentMethod")
                  },
                  model: {
                    value: _vm.paramsData.pay_type,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "pay_type", $$v)
                    },
                    expression: "paramsData.pay_type"
                  }
                },
                _vm._l(_vm.payType, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: !_vm.tableData.length },
                  on: { click: _vm.exportdata }
                },
                [_vm._v(" " + _vm._s(_vm.$t("export")) + " ")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addItem } },
                [_vm._v(" " + _vm._s(_vm.$t("add")) + " ")]
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function($event) {
                      return _vm.getList(1)
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("search")) + " ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.reqLoading,
              expression: "reqLoading"
            }
          ],
          attrs: { data: _vm.tableData, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "admin_name", label: _vm.$t("operator") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [_vm._v(" " + _vm._s(row.admin_name || "/") + " ")]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "state",
              label: _vm.$t("status"),
              "min-width": "120"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    row.state == 0
                      ? _c("div", [_vm._v(_vm._s(_vm.$t("pendingReview")))])
                      : _vm._e(),
                    row.state == 1
                      ? _c("div", [_vm._v(_vm._s(_vm.$t("approved")))])
                      : _vm._e(),
                    row.state == 2
                      ? _c("div", [_vm._v(_vm._s(_vm.$t("reviewRejected")))])
                      : _vm._e(),
                    row.state == 3
                      ? _c("div", [
                          _vm._v(_vm._s(_vm.$t("reviewedReplenishmentFailed")))
                        ])
                      : _vm._e(),
                    row.state == 4
                      ? _c("div", [
                          _vm._v(
                            _vm._s(_vm.$t("noReviewNeededReplenishmentFailed"))
                          )
                        ])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "uid", label: _vm.$t("gameUid") }
          }),
          _c("el-table-column", {
            attrs: { prop: "order_id", label: _vm.$t("orderId"), width: "370" }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "pay_channel_order_id",
              label: _vm.$t("paymentChannelOrder")
            }
          }),
          _c("el-table-column", {
            attrs: { prop: "product_id", label: _vm.$t("productId") }
          }),
          _c("el-table-column", {
            attrs: { prop: "pay_type", label: _vm.$t("paymentMethod") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.payType.find(function(i) {
                            return i.value == row.pay_type
                          }).label
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "reward",
              label: _vm.$t("item"),
              "min-width": "100"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      {
                        staticStyle: { color: "#409EFF", cursor: "pointer" },
                        on: {
                          click: function($event) {
                            return _vm.$refs.viewArticles.init(row.reward)
                          }
                        }
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("view")) + " ")]
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "expire_time", label: _vm.$t("replenishmentTime") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [_vm._v(" " + _vm._s(row.created_at) + " ")]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: _vm.$t("operation"), width: "120", fixed: "right" },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function(ref) {
                    var row = ref.row
                    return row.state == 0
                      ? [
                          _c(
                            "el-popconfirm",
                            {
                              attrs: {
                                title: _vm.$t("operation"),
                                "confirm-button-text": _vm.$t("approve"),
                                "cancel-button-type": "warning",
                                disabled: row.repair_state == 0
                              },
                              on: {
                                confirm: function($event) {
                                  return _vm.auditOrder(row, 1)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "controlsBtn",
                                  attrs: { slot: "reference" },
                                  slot: "reference"
                                },
                                [
                                  row.state == 1
                                    ? _c("p", [
                                        _vm._v(_vm._s(_vm.$t("approved")))
                                      ])
                                    : _vm._e(),
                                  row.state == 2
                                    ? _c("p", [
                                        _vm._v(_vm._s(_vm.$t("reviewRejected")))
                                      ])
                                    : _vm._e(),
                                  row.state == 3
                                    ? _c("p", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "reviewedReplenishmentFailed"
                                            )
                                          )
                                        )
                                      ])
                                    : _vm._e(),
                                  row.state == 4
                                    ? _c("p", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "noReviewNeededReplenishmentFailed"
                                            )
                                          )
                                        )
                                      ])
                                    : _vm._e(),
                                  row.state == 0
                                    ? _c("p", { staticClass: "color666" }, [
                                        row.repair_state == 1
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(_vm.$t("pendingReview"))
                                              )
                                            ])
                                          : _vm._e(),
                                        row.repair_state == 0
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(_vm.$t("underReview"))
                                              )
                                            ])
                                          : _vm._e()
                                      ])
                                    : _vm._e()
                                ]
                              )
                            ]
                          )
                        ]
                      : undefined
                  }
                }
              ],
              null,
              true
            )
          })
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          layout: "total,sizes, prev, pager, next",
          "current-page": _vm.paramsData.page,
          total: _vm.total
        },
        on: { "current-change": _vm.getList, "size-change": _vm.sizeChange }
      }),
      _c("addReplenishment", {
        ref: "addReplenishment",
        attrs: {
          propsData: {
            env_id: _vm.paramsData.env_id,
            serverList: _vm.serverListYJ
          }
        },
        on: {
          change: function($event) {
            return _vm.getList(_vm.paramsData.page)
          }
        }
      }),
      _c("viewArticles", { ref: "viewArticles" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }